import React from 'react';

import {connect} from "react-redux";
import * as cargoUtils from "../../utils/cargo";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/cargo';
import * as cargoActions from "../../actions/cargo";
import * as utils from "../../utils/utils";
import CWForm from "./CWForm";
import Checkbox from "./fields/Checkbox";

class OutturnInformationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item.item,
            schema: {
                type: "object",
                properties: {
                    outturnTonnes: {
                        type: "number",
                        title: l10n.cargo.outturnTonnes,
                    },
                    excessExclusion: {
                        type: "boolean",
                        title: l10n.cargo.excessExclusion,
                        locked: this.props.saving
                    },
                }
            },
            uiSchema: {
                excessExclusion: {"ui:field": "checkbox"},
            },
            fields: {
                checkbox: Checkbox,
            },
            isDirty: false,
            formData: cargoUtils.cargoToForm(this.props.item.item)
        }
    }

    static getFlooredFixed(x, d = 3) {
        x = x * Math.pow(10, d);

        if (isNaN(x)) {
            return NaN;
        }
        if (x > 0) {
            return Math.floor(x) / Math.pow(10, d);
        }
        return Math.ceil(x) / Math.pow(10, d);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.item.item !== nextProps.item.item) {
            this.setState({item: nextProps.item.item});
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if(this.state.item === undefined || this.state.item === null || !utils.notNullNorUndefined(this.state.item.id)){
            this.setState({item: formData}, () => {
                form.fog = this.state.item.fog.id;
                delete form.cargoPorts;
                this.props.dispatch(cargoActions.add(form, this.props.displayAll));
            })
        } else {
            this.setState({item: formData}, () => {
                delete form.cargoPorts;
                delete form.loadingPort;
                delete form.dischargingPort;
                this.props.dispatch(cargoActions.edit(form, this.props.displayAll));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    calculateFields = (event) => {
        if (event.formData.excessExclusion !== this.state.item.excessExclusion) {
            this.setState({
                ...this.state,
                item: event.formData
            }, this.forceUpdate());
        }

        if (event.formData.quantity !== this.state.item.quantity) {
            event.formData.value = event.formData.quantity * event.formData.perTonUsd;
            if (isNaN(event.formData.value)) {
                event.formData.value = 0;
            }
            this.setState({
                ...this.state,
                item: event.formData
            }, this.forceUpdate());
        } else if (event.formData.perTonUsd !== this.state.item.perTonUsd) {
            event.formData.value = event.formData.quantity * event.formData.perTonUsd;
            if (isNaN(event.formData.value)) {
                event.formData.value = 0;
            }
            this.setState({
                ...this.state,
                item: event.formData
            }, this.forceUpdate());

        } else if (event.formData.value !== this.state.item.value) {
            event.formData.perTonUsd =  event.formData.value / event.formData.quantity;
            if (isNaN(event.formData.perTonUsd)) {
                event.formData.perTonUsd = 0;
            }

            this.setState({
                ...this.state,
                item: event.formData
            }, this.forceUpdate());
        }
        this.handleChange(event);
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'outturn-information-form dirty':'outturn-information-form';

        if (this.props.loading || this.props.item.fog === undefined) {
            return (<div><Loader /></div>)
        }

        return (
            <div className={formClassName}>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    onSubmit={this.onSubmit}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onChange={this.calculateFields}
                    fields={this.state.fields}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>

                <br />

                {!isNaN(this.state.item.outturnTonnes) && <fieldset>
                    <div className="form-group field field-number">
                        <label className="control-label">{l10n.cargo.shortageTonnes} :</label>&nbsp;&nbsp;<span className="fake-readonly-input">{this.constructor.getFlooredFixed(this.state.item.quantity - this.state.item.outturnTonnes, 3)}</span>
                    </div>

                    <div className="form-group field field-number">
                        <label className="control-label">{l10n.cargo.shortagePercent} :</label>&nbsp;&nbsp;<span className="fake-readonly-input">{this.constructor.getFlooredFixed((this.state.item.quantity - this.state.item.outturnTonnes) / this.state.item.quantity * 100, 5)} %</span>
                    </div>
                </fieldset>}
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        fogs: state.fog.fogs,
        loading: state.cargo.loading,
        cargoes: state.cargo.cargoes,
        saving: state.cargo.saving,

        displayAll: state.connect.displayAll,
    });
})(OutturnInformationForm);


// WEBPACK FOOTER //
// ./src/components/forms/OutturnInformationForm.js